import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PolicyLayout } from "./components/site/PolicyLayout";
import { TermsOfUse } from "./components/site/TermsOfUse";
import "./styles/index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PolicyLayout title="Terms of Use" effectiveDate="August 17, 2026">
      <TermsOfUse />
    </PolicyLayout>
  </StrictMode>,
);
